// extracted by mini-css-extract-plugin
export default {"table_wrapper":"InputAbsensi_table_wrapper__YvSTx"};